/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  'en-US': {
    common: require('./en-US/common.json'),
  },
};
